import {
  Component,
  ViewEncapsulation,
  computed,
  input,
  InputSignal,
  Input,
  Signal,
  OnInit,
} from '@angular/core';

import { capitalize } from 'lodash';
import { CoreModule } from '../../../core/core.module';

@Component({
  selector: 'app-estimate',
  standalone: true,
  styleUrl: './estimate.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  template: `
    @if (!notAvailable()) {
      <div class="estimate-container">
        <p class="estimate" [attr.data-estimate]="estimate()">
          {{ estimate() | mqaCurrency: localeFormat }}/
        </p>
      </div>
      <p class="metric" [attr.data-metric]="metric()">{{ metricStr() }}</p>
      <p class="percent" [attr.data-percent]="percent()">({{ percent() }}%)</p>
    }
    @if (notAvailable()) {
      <span class="not-available">{{
        'main.mobile.not_available' | translate
      }}</span>
    }
  `,
  host: {
    type: 'div',
    role: 'region',
    'aria-live': 'polite',
  },
  imports: [CoreModule],
})
export class EstimateComponent implements OnInit {
  @Input()
  localeFormat: any;

  min: InputSignal<number> = input(0);

  max: InputSignal<number> = input(0);

  estimate: InputSignal<number> = input(0);

  metric: InputSignal<string> = input('');

  percent: InputSignal<number> = input(0);

  metricStr = computed(() => {
    return capitalize(this.metric().toLowerCase());
  });

  notAvailable: Signal<boolean> = computed(() => {
    const result = this.max() === null || this.max() < 1 || this.min() === null;
    return result;
  });

  ngOnInit() {
    /*console.log(
      'estimate.component.ngOnInit min',
      this.min(),
      'max',
      this.max(),
      'percent',
      this.percent(),
      'notAvailable',
      this.notAvailable()
    );*/
  }
}
